import { z } from "zod";
import {
  ControlDataTypeKey,
  Types
} from "../prop-controllers";
import { P, match } from "ts-pattern";
import {
  imageDataSchema,
  imageDataV0Schema
} from "../data";
const imagePropControllerDataV0Schema = imageDataV0Schema;
const imagePropControllerDataV1Schema = imageDataSchema;
const ImagePropControllerDataV2Type = "prop-controllers::image::v2";
const imagePropControllerDataV2Schema = z.object({
  [ControlDataTypeKey]: z.literal(ImagePropControllerDataV2Type),
  value: imagePropControllerDataV1Schema
});
const imagePropControllerDataSchema = z.union([
  imagePropControllerDataV0Schema,
  imagePropControllerDataV1Schema,
  imagePropControllerDataV2Schema
]);
function Image(options = {}) {
  return { type: Types.Image, version: 2, options };
}
function getImagePropControllerDataImageData(data) {
  return match(data).with(
    { [ControlDataTypeKey]: ImagePropControllerDataV2Type },
    (v2) => v2.value
  ).otherwise((v0) => v0);
}
function createImagePropControllerDataFromImageData(data, definition) {
  return match(definition).with(
    { version: 2 },
    () => ({
      [ControlDataTypeKey]: ImagePropControllerDataV2Type,
      value: data
    })
  ).otherwise(() => data);
}
function getImagePropControllerFileIds(data) {
  const value = getImagePropControllerDataImageData(data);
  return match(value).with(void 0, () => []).with(P.string, (v) => [v]).with({ type: "makeswift-file", version: 1 }, (v) => [v.id]).with({ type: "external-file", version: 1 }, () => []).exhaustive();
}
function copyImageData(data, context) {
  return match(data).with(P.string, (v) => context.replacementContext.fileIds.get(v) ?? v).with({ type: "makeswift-file", version: 1 }, (v) => ({
    ...v,
    id: context.replacementContext.fileIds.get(v.id) ?? v.id
  })).otherwise((v) => v);
}
function copyImagePropControllerData(data, context) {
  return match(data).with(void 0, () => void 0).with({ [ControlDataTypeKey]: ImagePropControllerDataV2Type }, (v1) => {
    const value = copyImageData(v1.value, context);
    if (value == null)
      return void 0;
    return {
      [ControlDataTypeKey]: ImagePropControllerDataV2Type,
      value
    };
  }).otherwise((v0) => copyImageData(v0, context));
}
export {
  Image,
  ImagePropControllerDataV2Type,
  copyImagePropControllerData,
  createImagePropControllerDataFromImageData,
  getImagePropControllerDataImageData,
  getImagePropControllerFileIds,
  imagePropControllerDataSchema
};
//# sourceMappingURL=image.js.map